module.exports = __webpack_public_path__ + "img/banner-3-2@2x.48038d27.jpg";